import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import { columnsRentalPaymentHistory } from "../../Global Functions/columnsAntd";
import { getRentalPaymentHistoryList } from "../../Redux/Actions/rentalBookingActions";
import ListTopSearch from "../../Global Functions/listTopSearch";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";

const ListRentalPaymentHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const { rentalPaymentHistoryList, loading } = useSelector((state) => state.rentalBooking || {});

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
    const payload = {
      page,
      limit: pageSize,
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(getRentalPaymentHistoryList(payload, showLoader));
      if (!showLoader) toast.success("List refreshed");
    } catch {
      if (showLoader) toast.error("Failed to fetch list");
    }
  }, [dispatch, debouncedSearch, dateRange]);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (rentalPaymentHistoryList?.data?.total) {
      setPagination((prev) => ({ ...prev, total: rentalPaymentHistoryList.data.total }));
    }
  }, [rentalPaymentHistoryList]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  const handleTableChange = (pagination) => setPagination(pagination);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleViewPayment = (record) => {
    navigate(`/rental_payment_history/view/${record._id}`);
  };

  return (
    <>
      <div className="bookings_table">
        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading="Rental Payment History"
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
            />
          </div>

          <div className="custom_table">
            <div style={{ padding: "0px 60px" }}>
              <Table
                dataSource={(Array.isArray(rentalPaymentHistoryList?.data?.payments) && rentalPaymentHistoryList.data.payments) || []}
                columns={columnsRentalPaymentHistory(handleViewPayment)}
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
                scroll={{ x: 2100, y: 500 }}
                rowKey="_id"
                rowClassName={() => "text-center"}
              />
            </div>
          </div>
        </div>
      </div>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListRentalPaymentHistory;